// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-tools[data-v-2a0477d9]{margin-top:15px;background:#fff;padding:20px 0;border-bottom:1px solid #e6ebed}", ""]);
// Exports
module.exports = exports;
